// Lib
import React from 'react';
import { ConnectedProps, connect } from 'react-redux';

// Utils
import dragAndDropStateSingleton from '../../../element/dnd/dragAndDropStateSingleton';

// Components
import LineEdgeDragPreview from '../../../element/line/dragPreview/LineEdgeDragPreview';
import ElementPositioner from '../../../element/ElementPositioner';

// Selector
import { getDragModifierKeys } from '../../../utils/dnd/modifierKeys/dragModifierKeysSelector';

// Constants
import { MODIFIER_KEYS } from '../../../utils/dnd/modifierKeys/dragModifierKeysConstants';

// Types
import { LineDragLayerProps } from '../dragTypes';

const connectDraggedLineEdgePreview = connect((state) => ({
    shouldSnapToAngle: getDragModifierKeys(state).get(MODIFIER_KEYS.shiftKey),
}));

export const DraggedLineEdgePreview = connectDraggedLineEdgePreview(
    ({
        item,
        offsetDiff,
        scrollDiff,
        initialClientOffset,
        initialSourceClientOffset,
        gridSize,
        shouldSnapToAngle,
    }: LineDragLayerProps & ConnectedProps<typeof connectDraggedLineEdgePreview>) => (
        <ElementPositioner elementId={item.id} element={item.element}>
            <LineEdgeDragPreview
                elementId={item.id}
                element={item.element}
                hoveredElementId={dragAndDropStateSingleton.hoveredElementId}
                draggedEdge={item.edge}
                offsetDiff={offsetDiff}
                scrollDiff={scrollDiff}
                initialClientOffset={initialClientOffset}
                initialSourceClientOffset={initialSourceClientOffset}
                pos={item.pos}
                shouldSnapToAngle={shouldSnapToAngle}
                gridSize={gridSize}
            />
        </ElementPositioner>
    ),
);
